"use client";

import { useSyncExternalStore } from "react";

// Bir kere subscribe çağrılsın yeterli; client mount sonrası getSnapshot=true
// dönmeye başlar. Server'da getServerSnapshot=false.
const subscribe = () => () => {};
const getSnapshot = () => true;
const getServerSnapshot = () => false;

/**
 * Component'in client tarafında mount olup olmadığını döndürür.
 * Portal, window erişimi veya client-only render kararı gereken yerlerde kullanılır.
 * React 19 `set-state-in-effect` kuralına uygun şekilde `useSyncExternalStore` kullanır.
 */
export function useIsClient(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
